// import React, { useState, useEffect, useRef } from 'react';
// import axios from 'axios';
// import { BsPencil, BsCheck, BsX } from "react-icons/bs";
// import { Row, Col, Form } from "react-bootstrap";
// const ClientView = ({ data, type, clientId, setClientDetails, setVendorDetails, onAvatarUpdate }) => {
//     const [isEditMode, setIsEditMode] = useState(false);
//     const [editedClientData, setEditedClientData] = useState({
//         ...data,
//         avatarUrl: data.avatar || '',
//     });
//     const [countries, setCountries] = useState([]);
//     const [currency, setCurrency] = useState('USD');
//     const didFetchRef = useRef(false);
//     const [editField, setEditField] = useState(null);

//     // Fetch countries
//     const fetchCountries = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');

//             const token = userInfo?.token;

//             const response = await axios.get(`${backendUrl}/api/countries`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,

//                 },
//             });
//             const countryList = response.data.Data;

//         // Find UAE country object by name
//         const uaeCountry = countryList.find(c => c.name === "United Arab Emirates");

//         // Sort countries: UAE first, then alphabetically
//         const sortedCountries = [...countryList].sort((a, b) => {
//             if (a.name === "United Arab Emirates") return -1;
//             if (b.name === "United Arab Emirates") return 1;
//             return a.name.localeCompare(b.name);
//         });

//         setCountries(sortedCountries);

//         // Set default country_id to UAE if not already set
//         if (!editedClientData.country_id && uaeCountry) {
//             setEditedClientData((prev) => ({
//                 ...prev,
//                 country_id: uaeCountry.id,
//                 currency: 'AED'
//             }));
//             setCurrency('AED');
//         }

//         } catch (error) {
//             console.error('Error fetching countries:', error);
//         }
//     };
//     useEffect(() => {
//         const selectedCountry = countries.find(c => c.id === editedClientData.country_id);
//         if (selectedCountry?.name === "United Arab Emirates") {
//             setCurrency("AED");
//             setEditedClientData(prevState => ({
//                 ...prevState,
//                 currency: "AED",
//             }));
//         } else if (editedClientData.country_id) {
//             setCurrency("USD");
//             setEditedClientData(prevState => ({
//                 ...prevState,
//                 currency: "USD",
//             }));
//         }
//     }, [editedClientData.country_id, countries]);



//     useEffect(() => {
//         if (!didFetchRef.current) {
//             fetchCountries();
//             didFetchRef.current = true;
//         }
//     }, []);

//     // Handle form input changes
//     const handleChange = (e) => {
//         const { name, value } = e.target;

//         if (name === 'country_id') {
//             // Ensure that value is parsed as a number (ID) or null if not selected
//             const parsedValue = value ? parseInt(value, 10) : null;
//             setEditedClientData((prevState) => ({
//                 ...prevState,
//                 [name]: parsedValue, // Store the numeric ID instead of the name
//             }));
//         } else {
//             setEditedClientData((prevState) => ({
//                 ...prevState,
//                 [name]: value.trim(),
//             }));
//         }
//     };

//     const handleAvatarChange = (e) => {
//         const file = e.target.files[0];
//         if (file) {
//             const tempUrl = URL.createObjectURL(file); // Temporary preview
//             setEditedClientData((prevData) => ({
//                 ...prevData,
//                 avatar: file, // Store the selected file
//                 avatarUrl: tempUrl, // Set preview URL
//             }));
//         }
//     };



//     const handleSave = async () => {
//         try {
//             const dataToUpdate = { ...editedClientData };
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');

//             const token = userInfo?.token;

//             // Send data to the backend
//             const response = await axios.post(
//                 `${backendUrl}/api/contacts/${clientId}?type=${type}&_method=PUT`,
//                 dataToUpdate,
//                 {
//                     headers: {
//                         Authorization: `Bearer ${token}`,
//                         'Content-Type': 'multipart/form-data',
//                         'Tenant-Origin': origin,

//                     },
//                 }
//             );

//             const updatedAvatarUrl = response.data?.Data?.avatar
//                 ? `${response.data.Data.avatar}`
//                 : dataToUpdate.avatarUrl;


//             const updatedDetails = {
//                 ...dataToUpdate,
//                 avatarUrl: updatedAvatarUrl, // Use new avatar
//             };

//             if (type === 'client') {
//                 setClientDetails((prevDetails) => ({
//                     ...prevDetails,
//                     ...updatedDetails,
//                 }));
//             } else if (type === 'vendor') {
//                 setVendorDetails((prevDetails) => ({
//                     ...prevDetails,
//                     ...updatedDetails,
//                 }));
//             }

//             // Notify parent about the new avatar
//             if (updatedAvatarUrl && onAvatarUpdate) {
//                 onAvatarUpdate(updatedAvatarUrl);
//             }

//             setEditField(null);
//         } catch (error) {
//             console.error('Error saving client details:', error);
//         }
//     };

//     useEffect(() => {
//         if (data.avatar) {
//             setEditedClientData((prevData) => ({
//                 ...prevData,
//                 avatarUrl: data.avatar, // Update avatar from API
//             }));
//         }
//     }, [data.avatar]);

//     const handleDownload = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem("user-info"));
//             const origin = localStorage.getItem("user-origin");
//             const token = userInfo?.token;

//             // Make the request to the backend to get the file
//             const response = await axios.get(
//                 `${backendUrl}/api/contacts/${clientId}/download?type=${type}`,
//                 {
//                     headers: {
//                         Authorization: `Bearer ${token}`,
//                         'Tenant-Origin': origin,

//                     },
//                     responseType: "blob", // Ensure the file is fetched as binary data
//                 }
//             );

//             // Log response headers for debugging
//             console.log('Response Headers:', response.headers);

//             const contentDisposition = response.headers['content-disposition'];
//             let fileName;

//             // Check if content-disposition header exists and extract the filename
//             if (contentDisposition) {
//                 const match = contentDisposition.match(/filename="(.+)"/);
//                 if (match) {
//                     fileName = match[1];
//                 }
//             }

//             // Log extracted filename for debugging
//             console.log('Extracted Filename:', fileName);

//             if (!fileName) {
//                 // Fallback if filename is not extracted
//                 fileName = 'downloaded-file';
//             }

//             // Create blob and initiate the download
//             const blob = new Blob([response.data], { type: response.headers['content-type'] });
//             const url = window.URL.createObjectURL(blob);
//             const link = document.createElement('a');
//             link.href = url;
//             link.setAttribute('download', fileName);
//             document.body.appendChild(link);
//             link.click();
//             link.remove();
//         } catch (error) {
//             console.error('Error downloading the file:', error);
//         }
//     };

//     const getCountryName = (id) => {
//         if (!id || countries.length === 0) return "--";
//         const country = countries.find((coun) => Number(coun.id) === Number(id));
//         return country ? country.name : "--";
//     };
//     const fields = [
//         { name: 'name', label: 'Name', type: 'text' },
//         { name: 'business_name', label: 'Business Name', type: 'text' },

//         { name: 'tax_number', label: 'VAT Number', type: 'text' },
//         { name: 'avatar', label: 'Profile Picture', type: 'file' },

//         { name: 'pay_term', label: 'Pay Term', type: 'text' },
//         { name: 'pay_term_condition', label: 'Pay Term Condition', type: 'select', options: [{ value: "days", label: "Days" }, { value: "months", label: "Months" }] },

//         { name: 'email', label: 'Email', type: 'text' },
//         { name: 'mobile', label: 'Mobile', type: 'text' },
//         { name: 'alternate_contact_no', label: 'Contact No', type: 'text' },

//         { name: 'country_id', label: 'Country', type: 'select', options: countries.map((coun) => ({ value: coun.id, label: coun.name })), format: getCountryName },
//         { name: 'state', label: 'State', type: 'text' },
//         { name: 'currency', label: 'Currency', type: 'text', readOnly: true },

//         { name: 'city', label: 'City', type: 'text' },
//         { name: 'zip', label: 'Zip Code', type: 'text' },
//         { name: 'tl_registration', label: 'TL Registration', type: 'text' },
//         { name: 'tl_registration_date', label: 'TL Registration Date', type: 'date' },
//         { name: 'tl_expired_date', label: 'TL Expired Date', type: 'date' },
//         { name: 'tl_registration_doc', label: 'TL Attachment', type: 'file' },

//         { name: 'address', label: 'Address', type: 'text' },
//     ];

//     const visibleFields = fields.filter((field) => {
//         if (field.name === 'currency') {
//             return editedClientData.country_id;
//         }
//         return true;
//     });

//     const rows = [];
//     for (let i = 0; i < visibleFields.length; i += 3) {
//         rows.push(visibleFields.slice(i, i + 3));
//     }
//     const handleFileChange = (e, fieldName) => {
//         const file = e.target.files[0];
//         if (file) {
//             const tempUrl = URL.createObjectURL(file); // Temporary preview
//             setEditedClientData((prevData) => ({
//                 ...prevData,
//                 [fieldName]: file, // Store the selected file (for upload)
//                 [`${fieldName}Url`]: tempUrl, // Set preview URL for images
//                 [`${fieldName}Name`]: file.name, // Store the file name for display
//             }));
//         }
//     };



//     return (
//         <div className="p-3 font-size-13">
//             <Row>
//                 {visibleFields.map((field, index) => (
//                     <Col md={6} key={index} className="mb-2 d-flex align-items-center ps-5">
//                         <strong className="view-label">{field.label}:</strong>
//                         <div className="editable-container d-flex align-items-center">
//                             {editField === field.name ? (
//                                 <div className="d-flex align-items-center">
//                                     {field.type === "file" ? (
//                                         <Form.Control
//                                             type="file"
//                                             name={field.name}
//                                             onChange={(e) => handleFileChange(e, field.name)}
//                                             autoFocus
//                                             className="form-control form-feild"
//                                             />
//                                     ) : field.type === "select" ? (
//                                         <Form.Select
//                                             name={field.name}
//                                             value={editedClientData[field.name] || ""}
//                                             onChange={handleChange}
//                                             autoFocus
//                                             className="form-control form-feild"
//                                             >
//                                             {field.options.map((option, idx) => (
//                                                 <option key={idx} value={option.value}>
//                                                     {option.label}
//                                                 </option>
//                                             ))}
//                                         </Form.Select>
//                                     ) : field.type === "date" ? (
//                                         <Form.Control
//                                             type="date"
//                                             name={field.name}

//                                             value={editedClientData[field.name] || ""}
//                                             onChange={handleChange}
//                                             autoFocus
//                                             className="form-control form-feild"
//                                             />
//                                     ) : (
//                                         <Form.Control
//                                             type="text"
//                                             name={field.name}
//                                             value={editedClientData[field.name] || ""}
//                                             onChange={handleChange}
//                                             autoFocus
//                                             className="form-control form-feild"
//                                             />
//                                     )}
//                                     <BsCheck className="text-success mx-2" onClick={handleSave} style={{ cursor: "pointer" }} />
//                                     <BsX className="text-danger" onClick={() => setEditField(null)} style={{ cursor: "pointer" }} />
//                                 </div>
//                             ) : (
//                                 <div className="hover1">
//                                     {field.name === "avatar" ? (
//                                         // Always show file input for avatar even when not editing
//                                         <Form.Control
//                                             type="file"
//                                             name={field.name}
//                                             onChange={(e) => handleFileChange(e, field.name)}
//                                             className="form-control form-feild"
//                                             accept="image/*"
//                                         />
//                                     ) : field.name === "tl_registration_doc" ? (
//                                         <span className="hover-field1" onClick={handleDownload} style={{ cursor: "pointer" }}>
//                                             {editedClientData[`${field.name}Name`] || editedClientData.tl_registration_doc?.split('/').pop() || "-"}
//                                         </span>
//                                     ) : field.name === "country_id" ? (
//                                         <span className="hover-field1">
//                                             {getCountryName(editedClientData.country_id)}
//                                         </span>
//                                     ) : (
//                                         <span className="hover-field1">{editedClientData[field.name] || "--"}</span>
//                                     )}
//                                       {field.name !== "currency" && (
//                                     <BsPencil className="text-primary pencil-icon1" onClick={() => setEditField(field.name)} />
//                                       )}
//                                     </div>
//                             )}
//                         </div>
//                     </Col>
//                 ))}
//             </Row>
//         </div>
//     );
// };

// export default ClientView;



import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Row, Col, Card } from "react-bootstrap";
import {
    FaUser,
    FaBuilding,
    FaEnvelope,
    FaPhone,
    FaMapMarkerAlt,
    FaGlobe,
    FaFileAlt,
    FaCalendarAlt,
    FaDollarSign
} from "react-icons/fa";

const ClientView = ({ data, type, clientId, setClientDetails, setVendorDetails, onAvatarUpdate }) => {
    const [countries, setCountries] = useState([]);
    const [currency, setCurrency] = useState('USD');
    const didFetchRef = useRef(false);

    // Fetch countries
    const fetchCountries = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/countries`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,
            });
            const countryList = response.data.Data;

            // Find UAE country object by name
            const uaeCountry = countryList.find(c => c.name === "United Arab Emirates");

            // Sort countries: UAE first, then alphabetically
            const sortedCountries = [...countryList].sort((a, b) => {
                if (a.name === "United Arab Emirates") return -1;
                if (b.name === "United Arab Emirates") return 1;
                return a.name.localeCompare(b.name);
            });

            setCountries(sortedCountries);

        } catch (error) {
            console.error('Error fetching countries:', error);
        }
    };

    useEffect(() => {
        if (!didFetchRef.current) {
            fetchCountries();
            didFetchRef.current = true;
        }
    }, []);

    const getCountryName = (id) => {
        if (!id || countries.length === 0) return "--";
        const country = countries.find((coun) => Number(coun.id) === Number(id));
        return country ? country.name : "--";
    };

    const getDisplayValue = (value) => {
        return value || "--";
    };

    const formatDate = (dateString) => {
        if (!dateString) return "--";
        try {
            return new Date(dateString).toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'short',
                day: 'numeric'
            });
        } catch (error) {
            return dateString;
        }
    };

    // Group fields by category for better organization
    const fieldGroups = [
        {
            title: "Basic Information",
            icon: <FaUser className="text-primary" />,
            fields: [
                { name: 'name', label: 'Full Name', icon: <FaUser size={14} />, value: getDisplayValue(data?.name) },
                { name: 'business_name', label: 'Business Name', icon: <FaBuilding size={14} />, value: getDisplayValue(data?.business_name) },
                { name: 'email', label: 'Email Address', icon: <FaEnvelope size={14} />, value: getDisplayValue(data?.email) },
                { name: 'mobile', label: 'Mobile Number', icon: <FaPhone size={14} />, value: getDisplayValue(data?.mobile) },
            ]
        },
        {
            title: "Contact Information",
            icon: <FaPhone className="text-info" />,
            fields: [
                { name: 'alternate_contact_no', label: 'Alternate Contact', icon: <FaPhone size={14} />, value: getDisplayValue(data?.alternate_contact_no) },
                { name: 'address', label: 'Address', icon: <FaMapMarkerAlt size={14} />, value: getDisplayValue(data?.address) },
                { name: 'city', label: 'City', icon: <FaMapMarkerAlt size={14} />, value: getDisplayValue(data?.city) },
                { name: 'state', label: 'State', icon: <FaMapMarkerAlt size={14} />, value: getDisplayValue(data?.state) },
                { name: 'zip', label: 'Zip Code', icon: <FaMapMarkerAlt size={14} />, value: getDisplayValue(data?.zip) },
                { name: 'country_id', label: 'Country', icon: <FaGlobe size={14} />, value: getCountryName(data?.country_id) },
            ]
        },
        {
            title: "Business Details",
            icon: <FaBuilding className="text-warning" />,
            fields: [
                { name: 'tax_number', label: 'VAT Number', icon: <FaFileAlt size={14} />, value: getDisplayValue(data?.tax_number) },
                { name: 'currency', label: 'Currency', icon: <FaDollarSign size={14} />, value: getDisplayValue(data?.currency) },
                { name: 'pay_term', label: 'Pay Term', icon: <FaCalendarAlt size={14} />, value: getDisplayValue(data?.pay_term) },
                { name: 'pay_term_condition', label: 'Pay Term Condition', icon: <FaCalendarAlt size={14} />, value: getDisplayValue(data?.pay_term_condition) },
            ]
        },
        {
            title: "Trade License Information",
            icon: <FaFileAlt className="text-success" />,
            fields: [
                { name: 'tl_registration', label: 'TL Registration', icon: <FaFileAlt size={14} />, value: getDisplayValue(data?.tl_registration) },
                { name: 'tl_registration_date', label: 'TL Registration Date', icon: <FaCalendarAlt size={14} />, value: formatDate(data?.tl_registration_date) },
                { name: 'tl_expired_date', label: 'TL Expiry Date', icon: <FaCalendarAlt size={14} />, value: formatDate(data?.tl_expired_date) },
                { name: 'tl_registration_doc', label: 'TL Attachment', icon: <FaFileAlt size={14} />, value: data?.tl_registration_doc ? "Document Available" : "No Document" },
            ]
        }
    ];

    return (
        <div className="p-3">
            {/* Profile Header Card */}
            {/* <Card className="mb-4 shadow-sm border-0">
                <Card.Body className="text-center">
                    <div className="d-flex align-items-center justify-content-center mb-3">
                        <div className="position-relative">
                            {data?.avatar ? (
                                <img
                                    src={`${process.env.REACT_APP_BACKEND_URL}/storage/${data.avatar}`}
                                    alt="Client Avatar"
                                    className="rounded-circle"
                                    style={{
                                        width: '100px',
                                        height: '100px',
                                        objectFit: 'cover',
                                        border: '4px solid #e9ecef'
                                    }}
                                />
                            ) : (
                                <div 
                                    className="rounded-circle d-flex align-items-center justify-content-center bg-primary text-white fw-bold"
                                    style={{
                                        width: '100px',
                                        height: '100px',
                                        fontSize: '2rem',
                                        border: '4px solid #e9ecef'
                                    }}
                                >
                                    {data?.name ? data.name.charAt(0).toUpperCase() : "?"}
                                </div>
                            )}
                        </div>
                    </div>
                    <h4 className="fw-bold text-dark mb-1">{getDisplayValue(data?.name)}</h4>
                    <p className="text-muted mb-2">{getDisplayValue(data?.business_name)}</p>
                    <div className="d-flex justify-content-center gap-3">
                        {data?.email && (
                            <div className="d-flex align-items-center text-muted">
                                <FaEnvelope className="me-2" />
                                <small>{data.email}</small>
                            </div>
                        )}
                        {data?.mobile && (
                            <div className="d-flex align-items-center text-muted">
                                <FaPhone className="me-2" />
                                <small>{data.mobile}</small>
                            </div>
                        )}
                    </div>
                </Card.Body>
            </Card> */}

            {/* Client Details Sections */}
            {fieldGroups.map((group, groupIndex) => (
                <Card key={groupIndex} className="mb-4 shadow-sm border-0">
                    <Card.Header className="bg-light border-0 py-3">
                        <div className="d-flex align-items-center">
                            {group.icon}
                            <h5 className="mb-0 ms-2 fw-semibold text-dark">{group.title}</h5>
                        </div>
                    </Card.Header>
                    <Card.Body className="p-0">
                        <Row className="g-0">
                            {group.fields.map((field, fieldIndex) => (
                                <Col md={6} key={fieldIndex}>
                                    <div className="p-3 border-bottom border-end client-detail-item">
                                        <div className="d-flex align-items-start">
                                            <div className="text-muted me-3 mt-1">
                                                {field.icon}
                                            </div>
                                            <div className="flex-grow-1">
                                                <label className="text-muted small mb-1 d-block fw-medium">
                                                    {field.label}
                                                </label>
                                                <div className="text-dark fw-semibold">
                                                    {field.value}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </Card.Body>
                </Card>
            ))}

            {/* Additional Information Card */}
            {/* <Card className="shadow-sm border-0">
                <Card.Header className="bg-light border-0 py-3">
                    <div className="d-flex align-items-center">
                        <FaFileAlt className="text-secondary" />
                        <h5 className="mb-0 ms-2 fw-semibold text-dark">Additional Information</h5>
                    </div>
                </Card.Header>
                <Card.Body>
                    <Row>
                        <Col md={6}>
                            <div className="mb-3">
                                <label className="text-muted small mb-1 d-block fw-medium">Client Type</label>
                                <div className="text-dark fw-semibold text-capitalize">
                                    {type || "--"}
                                </div>
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="mb-3">
                                <label className="text-muted small mb-1 d-block fw-medium">Client ID</label>
                                <div className="text-dark fw-semibold">
                                    {clientId || "--"}
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Card.Body>
            </Card> */}
        </div>
    );
};

export default ClientView;